// export const API_URL = "http://localhost:10000/api/"

export const API_URL = "https://data-shop-first-5139e0e980a0.herokuapp.com/api/"
